import React, { useContext, useEffect, useState } from "react";
import { PaymentInfoContext, PaymentRequest } from "../../App";

const PayNowContainer = ({ children }) => {
  const paymentInfo = useContext(PaymentInfoContext);

  const [paymentRequest, setPaymentRequest] = useState();

  const requestStripe = async () => {
    try {
      const payAmount = parseInt(paymentInfo.amount * 100);
      // return await stripe.paymentRequest({
      //   country: paymentInfo.country,
      //   currency: paymentInfo.currency?.toLowerCase() || 'usd',
      //   total: {
      //     label: 'IOLpay',
      //     amount: payAmount
      //   },
      //   requestPayerName: false,
      //   requestPayerEmail: false
      // });
    } catch (err) {
      console.error(err)
    }
  }

  // useEffect(() => {
    // if (paymentInfo && stripe) {
    //   (async () => {
    //     const stripeRes = await requestStripe();
    //     const res = await stripeRes?.canMakePayment();
    //     if (res) {
    //       setPaymentRequest(stripeRes);
    //     }
    //   })();
    // }
  // }, [paymentInfo, stripe])

  return (<PaymentRequest.Provider value={paymentRequest}>
    { children }
  </PaymentRequest.Provider>)
}

export default PayNowContainer
